import { Button } from '@/components/ui/Button'
import { cn } from '@/components/ui/cn'

interface RatingButtonsProps {
  onRate: (rating: 0 | 1 | 2 | 3) => void
  blocked?: boolean
  onBlockedAttempt?: () => void
}

const ratingButtons = [
  { rating: 0 as const, label: 'Again', className: 'bg-destructive hover:bg-destructive/90' },
  { rating: 1 as const, label: 'Hard', className: 'bg-orange-500 hover:bg-orange-600' },
  { rating: 2 as const, label: 'Good', className: 'bg-emerald-600 hover:bg-emerald-700' },
  { rating: 3 as const, label: 'Easy', className: 'bg-blue-600 hover:bg-blue-700' },
]

export function RatingButtons({ onRate, blocked = false, onBlockedAttempt }: RatingButtonsProps) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      {ratingButtons.map((button) => (
        <Button
          key={button.rating}
          className={cn(
            button.className,
            'min-h-12',
            blocked && 'pointer-events-auto opacity-50 saturate-[0.85]',
          )}
          aria-disabled={blocked}
          onClick={() => {
            if (blocked) {
              onBlockedAttempt?.()
              return
            }
            onRate(button.rating)
          }}
          data-testid={`rate-${button.label.toLowerCase()}`}
        >
          {button.label}
        </Button>
      ))}
    </div>
  )
}
